module.exports = {"341124100":"襄河镇","341124101":"古河镇","341124102":"大墅镇","341124103":"二郎口镇","341124104":"武岗镇","341124105":"马厂镇","341124106":"石沛镇","341124107":"十字镇","341124108":"西王镇","341124109":"六镇镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341124.json
// module id = 1024
// module chunks = 0